<script>
export default {
  name: 'CpDropdownMenu',
  components: {
    CpButton: require('../button').default,
  },
  directives: {
    margin: require('../directives/margins').margin,
    marginLeft: require('../directives/margins').marginLeft,
    marginRight: require('../directives/margins').marginRight,
  },
};
</script>
<template>
  <div class="dropdown">
    <a class="dropbtn">
      <i class="fal fa-question-circle fa-1-5x"></i>
      <span v-if="!$root.isMobile" class="buttons" v-margin-left="0.5">About CrowdBlue</span>
    </a>
    <div class="dropdown-content">
      <a href="/about">About Us</a>
      <a href="mailto:support@crowdblue.com">Support</a>
      <a href="/campaigns/learn">How Campaigns Work</a>
      <a href="/about/privacy">Privacy Policy</a>
      <a href="/about/terms">Terms of Use</a>
      <a href="/community-guidelines">Community Guidelines</a>
    </div>
  </div>
</template>

<style scoped>
.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown,
.dropdown:hover {
  cursor: pointer;
}

.dropbtn {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 5px;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: var(--white);
  width: max-content;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  left: 100%;
  bottom: 0px;
}

.dropdown-content a {
  color: black;
  padding: 12px;
  text-decoration: none;
  display: block;
  border-bottom: 1px solid var(--neutral3);
}

.dropdown-content a:last-child {
  border-bottom: none;
}

.dropdown-content a:hover {
  background-color: var(--neutral1);
}

.dropdown:hover .dropdown-content {
  display: block;
}

.dropdown:hover .dropbtn {
  color: var(--primary);
  background-color: var(--primary-blue-200);
  border-radius: 4px;
}

@media screen and (max-width: 1025px) {
  .dropbtn {
    padding-left: 10px;
  }
}

@media screen and (max-width: 768px) {
  .dropbtn {
    padding-left: 0;
  }
}
</style>
